import styled, { css } from 'styled-components';

import { PuzzleStatus } from '../../types';
import { StatusButtonProps } from '../Components/StatusButton/StatusButton';

export const Status = styled.button<StatusButtonProps>`
  position: relative;
  border-radius: 32px;
  border: none;
  width: ${({ width }) => `${width}px` || '200px'};
  height: ${({ height }) => `${height}px` || '58px'};
  font-weight: bold;
  padding: ${({ padding }) => padding || null};
  margin: ${({ margin }) => `${margin}px ` ?? '30px'};
  transition: 0.3s;
  ${({ theme, status }) => variantStyles(theme, status)}
`;

const variantStyles = (theme: any, status = 'Pending uploaded') =>
  ({
    [PuzzleStatus.PENDING_UPLOAD]: css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.yellow};
    `,
    [PuzzleStatus.PENDING_DELETE]: css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.yellow};
    `,
    [PuzzleStatus.APPROVED]: css`
      color: ${theme.colors.white};
      background: linear-gradient(180deg, #00c056 0%, #00bb54 13.02%, #009a45 100%);
    `,
    rejected: css`
      color: white;
      background-color: red;
    `,
    pending: css`
      color: white;
      background-color: #dd7a00;
    `,
    [PuzzleStatus.DECLINED]: css`
      color: ${theme.colors.gray};
      background-color: transparent;
    `,
  }[status]);
